<template>
  <v-dialog
    width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
    v-model="opened"
  >
    <v-card flat>
      <v-card-text class="align-center">
        <v-icon class="success--text" size="50">thumb_up</v-icon>
        <v-layout
          column
          align-center
          class="subheading pa-2 success--text font-weight-bold"
        >
          Well Done!
        </v-layout>
        <v-divider class="my-3" />
        <v-layout column align-center>
          You've successfully completed
          {{ currentQuestionnaire.tax_year }}
          {{ currentQuestionnaire.formatted_name }}!
          {{
            nextQuestionnaire
              ? 'It looks like you have another questionnaire to work on:'
              : ''
          }}
        </v-layout>
        <v-divider class="my-3" v-if="nextQuestionnaire" />
        <v-layout
          column
          align-center
          v-if="nextQuestionnaire"
          class="font-weight-bold"
        >
          {{ nextQuestionnaire.name }}
        </v-layout>
        <v-divider class="my-3" />
        <v-layout align-center>
          <v-btn
            outline
            block
            color="primary"
            class="text-none mr-2"
            @click="goToDashboard"
          >
            Go to Dashboard
          </v-btn>
          <v-btn
            block
            color="primary"
            @click="goToNextQuestionnaire"
            class="text-none ml-2"
            v-if="nextQuestionnaire"
            >Start the next item</v-btn
          >
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    opened: {
      type: Boolean,
    },

    currentQuestionnaire: {
      type: Object,
    },

    nextQuestionnaire: {
      type: Object,
    },
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      currentFirm: 'currentFirm',
    }),
  },

  methods: {
    goToDashboard() {
      if (this.$route.params.hash) {
        this.$router.push(`/${this.$route.params.hash}`);
      } else {
        this.$router.push(
          `/?companyId=${this.currentQuestionnaire.company_id}`,
        );
      }
    },
    goToNextQuestionnaire() {
      this.$router.push(
        `/questionnaire?companyId=${this.nextQuestionnaire.company_id}&questionnaireId=${this.nextQuestionnaire.questionnaire_id}`,
      );
    },
  },
};
</script>
